import { checkUserDetails } from 'api/authService';
import { useUser } from 'api/userService';
import { useEffect } from 'react';

const IframeHandler = (): null => {
  const { isLoggedIn } = useUser();
  const handlePostMessage = async (event: any) => {
      const landingPageOrigin = process.env.REACT_APP_LANDING_PAGE;

      if (event.origin !== landingPageOrigin) {
          return;
      }

      if (event.data === 'getUserStatus') {
          try {
              const userDetails = await checkUserDetails();
              // SECURITY: do not ship full user record cross-domain. The landing
              // page only needs to know "is the user logged in and who are they".
              // Email/provider/confirmed/blocked never leave this origin.
              const safeUserDetails = userDetails && {
                  id: userDetails.id,
                  username: userDetails.username,
              };
              event.source.postMessage({ isLoggedIn: true, userDetails: safeUserDetails }, event.origin);
          } catch {
              event.source.postMessage({ isLoggedIn: false }, event.origin);
          }
      }
  };

  useEffect(() => {
      window.addEventListener('message', handlePostMessage);

      return () => {
          window.removeEventListener('message', handlePostMessage);
      };
  }, []);

  return null;
};

export default IframeHandler;
